module.exports = __webpack_public_path__ + "img/icon-logoff.909db4e9.png";